import { Injectable } from '@angular/core';
import { BxDisclaimContent } from '@buildxact/ui-components/bx-disclaim';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { EstimatePlansTakeOffsStatesV2 } from '../entities/estimate-plans-take-offs-states-v2.model';

@Injectable({
    providedIn: 'root',
})
export class EstimatePlansTakeOffsStoresV2Service {
    public readonly estimatePlansTakeOffsStates$: Observable<EstimatePlansTakeOffsStatesV2>;
    // @ts-ignore TS2345
    private readonly estimatePlansTakeOffsStatesSource = new BehaviorSubject<EstimatePlansTakeOffsStatesV2>(null);
    public set estimatePlansTakeOffsStates(states: EstimatePlansTakeOffsStatesV2) {
        this.estimatePlansTakeOffsStatesSource.next(states);
    }

    public readonly estimatePlansTakeOffsNotices$: Observable<BxDisclaimContent[]>;
    // @ts-ignore TS2345
    private readonly estimatePlansTakeOffsNoticesSource = new BehaviorSubject<BxDisclaimContent[]>(null);
    public set estimatePlansTakeOffsNotices(notices: BxDisclaimContent[]) {
        this.estimatePlansTakeOffsNoticesSource.next(notices);
    }

    constructor() {
        this.estimatePlansTakeOffsStates$ = this.estimatePlansTakeOffsStatesSource.pipe(filter((states) => !!states));

        this.estimatePlansTakeOffsNotices$ = this.estimatePlansTakeOffsNoticesSource.pipe(
            filter((notices) => !!notices),
            distinctUntilChanged()
        );
    }
}
